// Mirror of utils/apiConfig.js — same placeholder-replaced-at-runtime pattern.
// Required env var; if neither REACT_APP_WIDGET_ORIGIN nor the runtime sed
// replacement provided a value, the app fails loudly at startup (per the
// project's "no silent env fallbacks" rule).

const URL_RE = /^https?:\/\//;
const PLACEHOLDER = "REACT_APP_WIDGET_ORIGIN_PLACEHOLDER";

const getWidgetOrigin = () => {
  const fromEnv = process.env.REACT_APP_WIDGET_ORIGIN;
  if (fromEnv && URL_RE.test(fromEnv)) return fromEnv;
  // PLACEHOLDER is sed-rewritten to the real URL in production. If sed ran,
  // it now matches URL_RE. If sed didn't run (local build w/o env), it still
  // reads "REACT_APP_WIDGET_ORIGIN_PLACEHOLDER" and we fall through to throw.
  if (URL_RE.test(PLACEHOLDER)) return PLACEHOLDER;
  throw new Error(
    "REACT_APP_WIDGET_ORIGIN is not configured. " +
      "Set it in .env for local dev, or via container env for production.",
  );
};

export const WIDGET_ORIGIN = getWidgetOrigin();
